export interface PosterElement {
  scaleY?: any;
  scaleX?: any;
  type: 'image' | 'text' | 'circle' | 'qrcode';
  id: string;
  left: number;
  top: number;
  width?: number;
  height?: number;
  radius?: number;
  src?: string;
  text?: string;
  fontSize?: number;
  fontFamily?: string;
  fontWeight?: string;
  fill?: string;
  textAlign?: string;
  opacity?: number;
  clipPath?: string;
  zIndex?: number;
}

export interface PosterConfig {
  width: number;
  height: number;
  backgroundColor: string;
  elements: PosterElement[];
}

// 获取图片真实尺寸的工具函数
const getImageDimensions = (src: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };
    img.src = src;
  });
};

export const generatePosterConfig = async (userInfo: {
  avatar?: string;
  phoneNumber?: string;
  qrCodeUrl?: string;
  bgImageUrl?: string;
}): Promise<PosterConfig> => {
  const canvasWidth = 375;
  const bottomContentHeight = 110;

  // 高清倍数
  const pixelRatio = 2;

  // 根据背景图片实际尺寸计算高度
  let bgHeight = canvasWidth * 1.33; // 默认4:3比例

  try {
    const bgImageSrc = userInfo.bgImageUrl || 'https://s.xiaopeng.com/xp-charge/charge/invite-new-guest/invite-share-bg.png';
    const dimensions = await getImageDimensions(bgImageSrc);

    // 按照图片实际比例计算高度，保持宽度为canvasWidth
    bgHeight = canvasWidth * (dimensions.height / dimensions.width);

    console.log('背景图尺寸:', dimensions, '计算后高度:', bgHeight);
  } catch (error) {
    console.warn('获取背景图尺寸失败，使用默认比例:', error);
    // 使用默认比例
  }

  const totalHeight = bgHeight + bottomContentHeight;

  const elements: PosterElement[] = [
    // 背景图
    {
      type: 'image',
      id: 'background',
      left: 0,
      top: 0,
      width: canvasWidth * pixelRatio,
      height: bgHeight * pixelRatio,
      src: userInfo.bgImageUrl || 'https://s.xiaopeng.com/xp-charge/charge/invite-new-guest/invite-share-bg.png',
      zIndex: 1
    },

      // 用户头像 - 圆形裁剪
      {
        type: 'image',
        id: 'avatar',
        left: 20 * pixelRatio,
        top: (totalHeight - bottomContentHeight + 28) * pixelRatio,
        width: 32 * pixelRatio,
        height: 32 * pixelRatio,
        radius: 16 * pixelRatio, // 圆形裁剪
        src: userInfo.avatar || 'https://xps14.xiaopeng.com/6f6ca5d3a2c5deb839db293de5f8c387.png',
        // clipPath: 'circle',
        zIndex: 3
      },

    // 手机号文本
    ...(userInfo.phoneNumber ? [{
      type: 'text' as const,
      id: 'phoneNumber',
      left: 60 * pixelRatio,
      top: (totalHeight - bottomContentHeight + 38) * pixelRatio,
      text: `好友${userInfo.phoneNumber}`,
      fontSize: 16 * pixelRatio,
      fontFamily: 'PingFang SC',
      fontWeight: 'normal',
      fill: '#000000',
      textAlign: 'left',
      zIndex: 4
    }] : []),

    // 提示文案
    {
      type: 'text',
      id: 'tipText',
      left: 20 * pixelRatio,
      top: (totalHeight - bottomContentHeight + 65) * pixelRatio,
      text: '送你一份小鹏充电专属好礼，赶快查收吧～',
      fontSize: 12 * pixelRatio,
      fontFamily: 'PingFang SC',
      fontWeight: 'normal',
      fill: 'rgba(0, 0, 0, 0.6)',
      textAlign: 'left',
      zIndex: 4
    },

    // 二维码
    ...(userInfo.qrCodeUrl ? [{
      type: 'image' as const,
      id: 'miniCode',
      left: (canvasWidth - 80 - 20) * pixelRatio, // 距离右边20px
      top: (totalHeight - 80 - 20) * pixelRatio, // 距离底部20px
      width: 80 * pixelRatio,
      height: 80 * pixelRatio,
      src: userInfo.qrCodeUrl,
      zIndex: 4
    }] : [])
  ];

  // 遍历 elements，给 type=image 且有 width/height 的元素补充 scaleX/scaleY
  const elementsWithScale = await Promise.all(elements.map(async el => {
    if (el.type === 'image' && el.src && el.width && el.height) {
      try {
        const { width: imgW, height: imgH } = await getImageDimensions(el.src);
        return {
          ...el,
          scaleX: el.width / imgW,
          scaleY: el.height / imgH
        };
      } catch {
        return el;
      }
    }
    return el;
  }));

  console.log('elementsWithScale', elementsWithScale);

  return {
    width: canvasWidth * pixelRatio,
    height: totalHeight * pixelRatio,
    backgroundColor: '#FFFFFF',
    elements: elementsWithScale
  };
};
